import { useLanguage } from "@/hooks/useLanguage";
import { cn } from "@/lib/utils";

type SupportedLanguage = "en" | "fr" | "ja";

const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: "English",
  fr: "Français",
  ja: "日本語",
};

export function LanguageSelect({ className }: { className?: string }) {
  const { language, setLanguage } = useLanguage();

  return (
    <select
      value={language}
      onChange={(e) => setLanguage(e.target.value as SupportedLanguage)}
      className={cn(
        "h-8 rounded-lg border border-input bg-transparent px-2.5 text-sm text-foreground outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
        className,
      )}
    >
      {(Object.entries(LANGUAGE_NAMES) as [SupportedLanguage, string][]).map(([value, label]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
}
